import React from 'react'
import HeartIcon from '../../../../assets/images/heart.svg'
import HeartFilledIcon from '../../../../assets/images/heart-filled.svg'
import PremiumIcon from '../../../../assets/images/premium-star.svg'
import classes from './cardBadges.module.css'
import classNames from 'classnames'

export const WishList = ({
    half = false,
    className,
    filled = false,
    onClick,
}) => {
    return (
        <button
            className={classNames(
                classes.wishList,
                half && classes.wishListHalf,
                className
            )}
            onClick={onClick}
        >
            <img
                src={filled ? HeartFilledIcon : HeartIcon}
                alt="Heart Icon"
                className={classes.wishListImage}
            />
        </button>
    )
}

export const DayIndicator = ({ day, dayNumber, left = false, className }) => (
    <div
        className={classNames(
            classes.dateIndicator,
            left && classes.dateIndicatorLeft,
            className
        )}
    >
        <span className={classes.dateIndicatorDay}>{day}</span>
        <span className={classes.dateIndicatorDayNumber}>{dayNumber}</span>
    </div>
)

export const PremiumIndicator = () => (
    <img src={PremiumIcon} alt="Premium Course" className={classes.premium} />
)
